import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/lib/i18n";

const FAQAccordion = ({ items, dataTestid = "faq-accordion" }) => {
  const { lang } = useLang();
  if (!items || items.length === 0) return null;
  return (
    <Accordion type="single" collapsible data-testid={dataTestid} className="w-full divide-y divide-white/5">
      {items.map((f) => (
        <AccordionItem
          key={f.id}
          value={f.id}
          className="border-b border-white/10 px-2 first:pt-0"
        >
          <AccordionTrigger
            data-testid={`${dataTestid}-trigger-${f.id}`}
            className="text-left text-base sm:text-lg font-semibold text-white py-6 hover:no-underline hover:text-[#00D4FF] [&_svg]:text-white/40 [&[data-state=open]_svg]:text-[#00D4FF]"
          >
            {lang === "nl" ? f.q_nl : f.q_en}
          </AccordionTrigger>
          <AccordionContent data-testid={`${dataTestid}-content-${f.id}`} className="text-white/65 text-[15px] leading-relaxed pb-6 pr-8">
            {lang === "nl" ? f.a_nl : f.a_en}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FAQAccordion;
